import { createFileRoute } from '@tanstack/react-router';
import { workSearchSchema } from '@/features/work/model/taskFilters';
import { WorkLayout } from '@/features/work/ui/WorkLayout';

export const Route = createFileRoute('/_authenticated/work')({
  validateSearch: workSearchSchema,
  component: WorkLayout,
});
